import { useEffect, useState } from "react";
import { motion } from "framer-motion";

const links = [
  { label: "INICIO", href: "#inicio" },
  { label: "PORTFOLIO", href: "#portfolio" },
  { label: "SERVICIOS", href: "#servicios" },
];

export const Navigation = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleClick = (e, href) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <motion.header
      data-testid="nav-header"
      initial={{ y: -40, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ type: "spring", stiffness: 100, damping: 15, delay: 0.1 }}
      className={`fixed top-0 left-0 right-0 z-40 transition-colors duration-300 ${
        scrolled ? "bg-black/80 backdrop-blur-md" : "bg-transparent"
      }`}
    >
      <div className="border-b border-divider">
        <div className="mx-auto flex h-20 md:h-24 items-center justify-between px-6 md:px-10">
          <a
            href="#inicio"
            onClick={(e) => handleClick(e, "#inicio")}
            data-testid="nav-logo"
            className="flex items-center gap-3 hover:opacity-80 transition-opacity"
          >
            <img
              src="https://res.cloudinary.com/jqvef0es/image/upload/v1783186298/logo_negativo_vbr4dg.svg"
              alt="Asombro"
              className="h-10 md:h-12 w-auto"
            />
          </a>

          <nav className="flex items-center gap-6 md:gap-10">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={(e) => handleClick(e, l.href)}
                data-testid={`nav-link-${l.label.toLowerCase()}`}
                className="font-mono text-[11px] md:text-xs uppercase tracking-[0.18em] text-white/80 hover:text-rust transition-colors duration-200"
              >
                {l.label}
              </a>
            ))}
          </nav>
        </div>
      </div>
    </motion.header>
  );
};
